module.exports = __webpack_public_path__ + "img/Crown_Plaza_Hotel.4f10123f.svg";